import { GeneralSettingsForm } from "../GeneralSettingsForm";

export const EditGeneralSettings = () => {
  return <GeneralSettingsForm />;
};
